import ContentCard from '../ContentCard/ContentCard';
import styles from './ContentGrid.module.css';
export default function ContentGrid({items,tabIndex,loading,error,ytError,year,hasKey,onSelect}) {
  if (loading) return <div className={styles.c}><div style={{fontSize:40}}>🌙</div><p>Loading {year}...</p></div>;
  if (error) return <div className={styles.err}>⚠️ {error}</div>;
  if (!items||!items.length) return <div className={styles.c}><div style={{fontSize:48}}>📭</div><p>No content for Ramadan {year}</p>{!hasKey&&<p className={styles.hint}>Add a TMDB key for live data</p>}</div>;
  return <>
    {ytError&&<div className={styles.ytErr}>⚠️ YouTube unavailable: {ytError}</div>}
    <div className={styles.grid}>{items.map((it,i)=><ContentCard key={it.id||i} item={it} tabIndex={tabIndex} onSelect={onSelect}/>)}</div>
  </>;
}